import React from 'react';
import Button from '../common/Button';

function ServiceModal({ service, form, validationErrors, onClose, onSave, onChange }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: 'rgba(8,17,31,0.55)' }}>
      <div className="bg-white rounded-[12px] p-6 w-full max-w-[500px] max-h-[90vh] overflow-y-auto cs-content-scroll shadow-2xl mx-4">
        <div className="flex items-center justify-between mb-4 pb-4 border-b" style={{ borderColor: '#ddd6c6' }}>
          <h3 className="text-[18px] font-bold text-[#08111f]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {service ? 'Edit Service' : 'Add New Service'}
          </h3>
          <button
            onClick={onClose}
            className="p-2 rounded-lg transition-colors hover:bg-[#f8f5ef]"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[12px] font-medium text-[#08111f] mb-1">Service Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => onChange({ ...form, name: e.target.value })}
              className="w-full px-3 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#e8e2d6' }}
              required
            />
          </div>

          <div>
            <label className="block text-[12px] font-medium text-[#08111f] mb-1">Slug</label>
            <input
              type="text"
              value={form.slug}
              onChange={(e) => onChange({ ...form, slug: e.target.value })}
              className="w-full px-3 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#e8e2d6' }}
              required
            />
          </div>

          <div>
            <label className="block text-[12px] font-medium text-[#08111f] mb-1">Description</label>
            <textarea
              value={form.description}
              onChange={(e) => onChange({ ...form, description: e.target.value })}
              className="w-full px-3 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#e8e2d6' }}
              rows={3}
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-[12px] font-medium text-[#08111f] mb-1">Price</label>
              <input
                type="number"
                value={form.price}
                onChange={(e) => onChange({ ...form, price: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
                style={{ borderColor: '#e8e2d6' }}
                required
              />
            </div>

            <div>
              <label className="block text-[12px] font-medium text-[#08111f] mb-1">Category</label>
              <select
                value={form.category}
                onChange={(e) => onChange({ ...form, category: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
                style={{ borderColor: '#e8e2d6' }}
                required
              >
                <option value="document_processing">Document Processing</option>
                <option value="filing">Filing</option>
                <option value="compliance">Compliance</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-[12px] font-medium text-[#08111f] mb-1">Estimated Time</label>
            <input
              type="text"
              value={form.estimatedTime}
              onChange={(e) => onChange({ ...form, estimatedTime: e.target.value })}
              className="w-full px-3 py-2 border rounded-lg text-[13px] outline-none transition-shadow focus:shadow-sm focus:border-[#145f5f40]"
              style={{ borderColor: '#e8e2d6' }}
              placeholder="e.g., 2-3 business days"
            />
          </div>

          <div className="flex items-center justify-between pt-4">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={form.isActive}
                onChange={(e) => onChange({ ...form, isActive: e.target.checked })}
                className="rounded"
              />
              <span className="text-[13px] text-[#08111f]">Active</span>
            </label>

            <div className="flex justify-end gap-3">
              <Button variant="ghost" onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="primary">
                {service ? 'Update' : 'Create'} Service
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ServiceModal;
